import { Fragment, useEffect, useState } from "react";
import Section from "../../../components/base/Section";
import Layout from "../../../components/layouts/Layout";
import { getUser, setPage, useHub, useScreen } from "../../../core/Global";
import { Link, useParams } from "react-router-dom";
import { API_ROUTES } from "../../../core/Constants";
import UserGroup from "../models/UserGroup";
import Icon from "../../../components/base/Icon";
import FlexRow from "../../../components/base/FlexRow";
import ScrollContainer from "../../../components/base/ScrollContainer";
import UserGroupEdit from "../components/UserGroupEdit";
import UserGroupUsers from "../components/UserGroupUsers";
import UserGroupRolesForm from "../components/UserGroupRolesForm";
import UserGroupIPRestrict from "../components/UserGroupIPRestrict";
import { groupRoleCategories } from "../utils/roleCategories";
import "../components/UserGroupRoles.css";


interface IPageLink {
    name: string
    icon: any
    slug: string
    default?: boolean
}

export default function UserGroupManage() {

    const hub = useHub();
    const user = getUser();
    const screen = useScreen();
    const { selectedId, selectedPage, selectedGroup } = useParams();

    // when on the roles page without a category, the first one is shown
    const activeGroupSlug = selectedGroup ?? groupRoleCategories[0].slug;

    const [fetching, fetchingSet] = useState<boolean>(true);
    const [model, modelSet] = useState<UserGroup>();
    const [pages, pagesSet] = useState<IPageLink[]>([]);

    const bindLinks = () => {
        var arr: IPageLink[] = [];

        arr.push({
            name: "Edit Group",
            icon: "pen",
            slug: "edit",
            default: true
        });

        arr.push({
            name: "Users in Group",
            icon: "users",
            slug: "users"
        });

        arr.push({
            name: "Roles & Permissions",
            icon: "lock",
            slug: "roles"
        });

        arr.push({
            name: "IP Restriction",
            icon: "network-wired",
            slug: "ip-restriction"
        });

        pagesSet(p => [...arr]);
    }

    const fetchGroup = () => {
        fetchingSet(true);
        hub.Get(API_ROUTES.UsersGroups + selectedId, res => {
            if (res.success) {
                modelSet(res.data);
                fetchingSet(false);
                bindLinks();
                setPage(res.data.name, "Users", "User Groups");
            }
        })
    }

    useEffect(() => {
        fetchGroup();
    }, [selectedId])


    return (
        <Layout wide fitToolbar paddingBottom={0} paddingTop={0}>
            <Section fluid fit>

                <FlexRow alignItems="start">

                    <ScrollContainer className="w-100 w-lg-250px w-xl-300px border-end">
                        <div className="card card-flush" style={{ height: screen.heightDoc }}>
                            <div className="card-body pt-5 px-3">
                                <div className="menu menu-column menu-rounded menu-state-bg menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary">

                                    {
                                        pages.map((p, k) => {
                                            const isActive = (window.isNullOrEmpty(selectedPage) && p.default) || selectedPage?.toLowerCase() == p.slug;
                                            const isRolesOpen = p.slug == "roles" && isActive;

                                            const parentItem = (
                                                <div className="menu-item mb-1 mb-xxl-3">
                                                    <Link to={`/accounts/usergroup/${selectedId}/${p.slug}`} className={"menu-link" + (isActive ? " active" : "")}>
                                                        <span className="menu-icon">
                                                            <span className="svg-icon svg-icon-2 me-3">
                                                                <Icon icon={p.icon} type="solid" className={(isActive ? "" : " text-gray-700")} />
                                                            </span>
                                                        </span>
                                                        <span className={"menu-title fw-bold fs-7 fs-xxl-6" + (isActive ? "" : " text-gray-700")}>{p.name}</span>
                                                    </Link>
                                                </div>
                                            );

                                            if (isRolesOpen) {
                                                return (
                                                    <div key={k} className="grp-roles-open mb-1 mb-xxl-3">
                                                        {parentItem}
                                                        <div className="grp-roles-submenu">
                                                            {
                                                                groupRoleCategories.map((c, ck) => {
                                                                    const catActive = activeGroupSlug == c.slug;
                                                                    return (
                                                                        <div key={ck} className="menu-item">
                                                                            <Link to={`/accounts/usergroup/${selectedId}/roles/${c.slug}`} className={"menu-link py-2" + (catActive ? " active" : "")}>
                                                                                <span className="menu-icon">
                                                                                    <span className="svg-icon svg-icon-3 me-3">
                                                                                        <Icon icon={c.icon as any} type="solid" className={(catActive ? "" : " text-gray-700")} />
                                                                                    </span>
                                                                                </span>
                                                                                <span className={"menu-title fw-bold fs-8 fs-xxl-7" + (catActive ? "" : " text-gray-700")}>{c.title}</span>
                                                                            </Link>
                                                                        </div>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                );
                                            }

                                            return <Fragment key={k}>{parentItem}</Fragment>;
                                        })
                                    }

                                </div>
                            </div>
                        </div>
                    </ScrollContainer>

                    <ScrollContainer className="flex-row-fluid">

                        {
                            !fetching && model &&
                            <>
                                {
                                    (window.isNullOrEmpty(selectedPage) || selectedPage == "edit") &&
                                    <UserGroupEdit model={model} onUpdate={g => modelSet(g)} />
                                }

                                {
                                    selectedPage == "users" && <UserGroupUsers model={model} />
                                }

                                {
                                    selectedPage == "roles" && <UserGroupRolesForm model={model} groupSlug={activeGroupSlug} />
                                }

                                {
                                    selectedPage == "ip-restriction" && <UserGroupIPRestrict model={model} />
                                }
                            </>
                        }

                    </ScrollContainer>

                </FlexRow>

            </Section>
        </Layout>
    )
}
